import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class PerformanceParameterService {

  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }
  
  listTypesofRepairs(
    pageIndex: number,
    pageSize: number,
    sortProperty?: string,
    sortDirection?: string,
    name?: string,
    description?: string,
  ) {
    const params = new HttpParams().set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || 'name')
      .set('sortDirection', sortDirection || 'asc')
      .set('name', name || '')
      .set('description', description || '')

    return this.http.get(`${this.baseUrl}/v1/repair-types`, { params })
  }
  listPerfomanceParameter(
    pageIndex: number,
    pageSize: number,
    contractId: string | null,
    sortDirection?: string,
    sortProperty?: string,
    tipoDefeito?: string,) {
    const params = new HttpParams().set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('tipoDefeito', tipoDefeito || '')

    return this.http.get(`${this.baseUrl}/v1/contracts/${contractId}/performance-parameters`, { params })
  }

  createPerfomanceParameter(contractId: any, formData: any) {
    return this.http.post(`${this.baseUrl}/v1/contracts/${contractId}/performance-parameters`, { ...formData })
  }

  editPerfomanceParameter(contractId: any, formData: any, perfomanceParaneterId: any) {
    return this.http.put(`${this.baseUrl}/v1/contracts/${contractId}/performance-parameters/${perfomanceParaneterId}`, { ...formData })
  }

  deletePerfomanceParameter(contractId: any, perfomanceParaneterId: any) {
    return this.http.delete(`${this.baseUrl}/v1/contracts/${contractId}/performance-parameters/${perfomanceParaneterId}`)
  }
  getHistoryParameter(contractId: string | null,  perfomanceParaneterId: string | null, pageIndex:number = 0){
    return this.http.get(this.baseUrl + `/v1/contracts/${contractId}/performance-parameters/${perfomanceParaneterId}/history?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`);
  }
  listPatology(
    pageIndex: number,
    pageSize: number,
    sortProperty?: string,
    sortDirection?: string,
    name?: string,
    description?: string,
  ) {
    const params = new HttpParams().set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || 'name')
      .set('sortDirection', sortDirection || 'asc')
      .set('name', name || '')
      .set('description', description || '')

    return this.http.get(`${this.baseUrl}/v1/pathologies`, { params })
  }

  validatePerfomanceParameter(contractId: any, data:any) {
    const formData = new FormData();
    formData.append('objetoOriginal', data?.file);
    return this.http.post(`${this.baseUrl}/v1/contracts/${contractId}/performance-parameters/validate-import`, formData)
  }
  importPerfomanceParameter(contractId: any, data:any, file:any, cpnj: any) {
    const formData = new FormData();
    const registrosValidosBlob = new Blob(
      [JSON.stringify(data?.registrosValidos)],
      { type: 'application/json' }
    );
    formData.append('registrosValidos', registrosValidosBlob);
    formData.append('nomeArquivo', file?.name);
    const fileExtension = file.type.split('/')[1];
    formData.append('tipoMime', fileExtension);
    formData.append('categoria', 'cadastro_contrato');
    formData.append('subCategoria', cpnj);
    formData.append('objetoOriginal', file?.file);
    return this.http.post(`${this.baseUrl}/v1/contracts/${contractId}/performance-parameters/import`, formData)
  }
}
